import React, { useState } from 'react';

const CardzonePayment = () => {
  const [cardDetails, setCardDetails] = useState({
    name: '',
    number: '',
    expiry: '',
    cvc: ''
  });
  const [amount, setAmount] = useState('100');

  const handleChange = (e) => {
    setCardDetails({ ...cardDetails, [e.target.name]: e.target.value });
  };

  const handlePayment = async () => {
    try {
      // Step 1: Get key and purchase ID
      const keyExchangeRes = await fetch('/key-exchange', { method: 'POST' });
      const keyData = await keyExchangeRes.json();
      const { purchaseId, privateKeyPem,publicKey, mac } = keyData.data;

      // Step 2: Ask backend to prepare transaction
      const transactionRes = await fetch('/prepare-transaction', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ purchaseId, privateKeyPem, mac, publicKey,cardDetails, amount })
      });

      const { data } = await transactionRes.json();

      // Step 3: Build and submit form to Cardzone
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://3dsecure.bob.bt/3dss/mercReq';
      form.target = 'cardzoneFrame';

      Object.entries(data).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } catch (err) {
      console.error('❌ Payment failed:', err);
      alert('Payment failed. Check console for details.');
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white shadow-md rounded mt-10">
      <h2 className="text-2xl font-bold mb-6 text-center">Pay with Cardzone</h2>
      <form onSubmit={(e) => { e.preventDefault(); handlePayment(); }} className="space-y-4">
        <input type="text" name="name" placeholder="Cardholder Name" value={cardDetails.name} onChange={handleChange} className="w-full p-2 border rounded" required />
        <input type="text" name="number" placeholder="Card Number" value={cardDetails.number} onChange={handleChange} className="w-full p-2 border rounded" required />
        <div className="flex gap-4">
          <input type="text" name="expiry" placeholder="MMYY" value={cardDetails.expiry} onChange={handleChange} className="w-full p-2 border rounded" required />
          <input type="text" name="cvc" placeholder="CVC" value={cardDetails.cvc} onChange={handleChange} className="w-full p-2 border rounded" required />
        </div>
        <button type="submit" className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700">Pay Nu. {amount}</button>
      </form>

      <iframe
        name="cardzoneFrame"
        title="Cardzone Frame"
        style={{ width: '100%', height: '500px', border: '1px solid #ccc', marginTop: '20px' }}
      />
    </div>
  );
};

export default CardzonePayment;
